/*
	Generated on 07/05/2025 by UI Generator PRICES-IDE
	https://amanah.cs.ui.ac.id/research/ifml-regen
	version 3.9.0
*/
import React, { useEffect, useState, useContext} from 'react'
import { Button, Spinner } from "@/commons/components"
import * as Layouts from '@/commons/layouts';
import { Link } from "react-router";
import { useParams } from "@/commons/hooks/useParams"
import { HeaderContext } from "@/commons/components"
import { useNavigate } from "react-router";
import { useAuth } from '@/commons/auth';
import GrupCard from "../components/GrupCard";

import getGrupMataKuliahDataBinding from '../services/getGrupMataKuliahDataBinding'
const CariGrupMataKuliahPage = props => {
const { parentMataKuliahId, id } = useParams()
	const { checkPermission } = useAuth();

	const [isLoading, setIsLoading] = useState({
	listRowGrupMataKuliah: false,

	});
	const { setTitle } = useContext(HeaderContext);

const [grupMataKuliahDataBinding, setGrupMataKuliahDataBinding] = useState()
	
	
	

	useEffect(() => {
		

		const fetchData = async () => {
			try {
				setIsLoading(prev => ({...prev, listRowGrupMataKuliah: true}))
				const { data: grupMataKuliahDataBinding } = await getGrupMataKuliahDataBinding({ })
				setGrupMataKuliahDataBinding(grupMataKuliahDataBinding.data)
			} finally {
				setIsLoading(prev => ({...prev, listRowGrupMataKuliah: false}))
			}
		}
		fetchData()
  	}, [])

	
	useEffect(() => {
		setTitle("Cari Grup Mata Kuliah Page")
	}, []);
return (
	<Layouts.ViewContainerLayout
		buttons={
			<>
			<Layouts.ViewContainerBackButtonLayout>
			  	<Link to={`/matakuliah/${id}
			  	`}>
			  		<Button className="p-4" variant="secondary">
			  		  Kembali
			  		</Button>
			  	</Link>
			  	
			  	
			  </Layouts.ViewContainerBackButtonLayout>
			</>
		}
	>
<Layouts.ListContainerCardLayout
	title={"Grup Mata Kuliah"}
	singularName={"Grup"}
	items={[grupMataKuliahDataBinding]}
	isLoading={isLoading.listRowGrupMataKuliah}
>
	<GrupCard
		grupMataKuliahDataBinding={grupMataKuliahDataBinding}
		
  	/>
</Layouts.ListContainerCardLayout>

	</Layouts.ViewContainerLayout>
  )
}
export default CariGrupMataKuliahPage

